import { render, staticRenderFns } from "./StopOverviewMobile.vue?vue&type=template&id=96261494&scoped=true&"
import script from "./StopOverviewMobile.vue?vue&type=script&lang=js&"
export * from "./StopOverviewMobile.vue?vue&type=script&lang=js&"
import style0 from "./StopOverviewMobile.vue?vue&type=style&index=0&id=96261494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96261494",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96261494')) {
      api.createRecord('96261494', component.options)
    } else {
      api.reload('96261494', component.options)
    }
    module.hot.accept("./StopOverviewMobile.vue?vue&type=template&id=96261494&scoped=true&", function () {
      api.rerender('96261494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages-mobile/Stops/StopOverviewMobile.vue"
export default component.exports